module.exports = __webpack_public_path__ + "static/img/setting.9a36286e.png";